module.exports = "<ol class=breadcrumb> <li ng-repeat=\"item in paths track by $index\"> <a ng-class=\"{inactive: ($index === paths.length -1)}\" ui-sref={{item.href}}>{{ item.title }}</a> </li> </ol> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/breadcrumb/view.html
// module id = FB1Z
// module chunks = 0